<template>
	<a-modal
        :visible="visible"
        :confirm-loading="isLoading"
        @cancel="handleCancel"
    >

        <!-- custome footer for hide btn -->
        <template #footer>
            <!-- <a-button key="back" @click="handleCancel">Return</a-button> -->
            <!-- <a-button  key="submit" type="primary" :loading="loading" @click="handleOk">Submit</a-button> -->
        </template>

        <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{paddingTop: '12px',}">
            <template #title>
                <h6 style="margin-bottom: 10px;" v-show="isOfficialSelected">
                    <a-avatar
                        slot="avatar"
                        size="large"
                        shape="circle"
                        :src="officialImageUrl"
                        style="margin-right: 10px;"
                    />
                    {{ locale == 'en' ? selectedOfficialForReview.name : selectedOfficialForReview.nameBn }}
                </h6>			
                <!-- <p>this month <span class="text-success">+20%</span></p>	 -->
                
                <div v-show="isOfficialSelected" style="display: flex; align-items: center; justify-content: center; flex-direction: column;">
                    <a-date-picker 
                        size="small" 
                        v-model="selectedDate" 
                        format="DD MMM, yyyy" 
                        :disabledDate="current => current && current < moment()"
                    />
                    <h6 style="margin-top: 40px;">{{$t('appointment-time-line.sub-title')}} {{ selectedDate.format('DD MMM, yyyy (dddd)')}}</h6>
                </div>
                

                
            </template>
            <a-spin :spinning="isLoading" size="large" v-show="isOfficialSelected">
                <div class="spin-content">
                    <a-timeline class="appointment-timeline" style="min-height: 480px; max-height: 480px; overflow-y: scroll !important;">
                        <appointment-timeline-item 
                            v-for="(item, i) in selectedSchedules" 
                            :key="i" 
                            :item="item" 
                            @approved="(e) => $emit('approved', e)"
                            @rescheduled="(e) => $emit('rescheduled', e)"
                            @parentModal="parentModal"
                            @cancel="performCancel"
                        />
                    </a-timeline>
                </div>
            </a-spin>
            <div v-show="!isOfficialSelected" style="min-height: 600px; max-height: 600px; overflow-y: scroll !important; display: flex; align-items: center; justify-content: center;">
                <a-empty
                    image="/images/empty.png"
                    :image-style="{ height: '60px' }">
                    <span slot="description"> 
                        <b class="text-primary">{{ $t("state-messages.no-official-selected") }}</b>
                    </span>
                </a-empty>
            </div>
            
        </a-card>
        <!-- / Orders History Timeline Card -->
    </a-modal>
</template>

<script>

import moment from 'moment';
import { mapActions, mapState } from 'pinia';
import { useAppointmentsStore } from '../../../../stores/appointments-store.js';
import { useLocaleStore } from "../../../../stores/locale-store.js"
import { toastMixin } from '../../../../mixins/ToastMixin.js';
import AppointmentTimelineItem from './../../timelines/AppointmentTimelineItem.vue';

export default ({
    name: "AppointmentTimeLineModal",
    components: {
        AppointmentTimelineItem
    },
    mixins: [ toastMixin ],
    data() {
        return {
            isLoading: false,
            timelines: [],
            selectedDate: moment().add(1, 'days'),
            moment: moment,
            visible: false,
        }
    },
    computed: {
        // screenWidth(){
        //     return window.screen.width;
        // },
        ...mapState(useAppointmentsStore, [ 'selectedOfficialForReview', 'schedules' ]),
        ...mapState(useLocaleStore, ['locale']),
        isOfficialSelected() {
            return this.selectedOfficialForReview && this.selectedOfficialForReview.id;
        },
        selectedSchedules() {
            try {
                return this.schedules[this.selectedOfficialForReview.id].filter(i => i.date == this.selectedDate.format('YYYY-MM-DD'))[0].list || []
            } catch(error) {
                return [];
            }  
        },
        officialImageUrl() {
            if (this.selectedOfficialForReview && this.selectedOfficialForReview.imageUrl && this.selectedOfficialForReview.imageUrl.length > 0) {
                return this.selectedOfficialForReview.imageUrl;
            }
            return '/images/default-avatar.jpg';
        }
    },
    methods: {
        showModal(){
            if (window.screen.width <= 767 )
                this.visible = true;
        },
        parentModal(e){
            console.log(e);
            this.visible = false;
        },
        handleCancel() {
            this.visible = false;
        },
        ...mapActions(useAppointmentsStore, [ 'fetchAndCacheApointments', 'cancelAppointment' ]),
        fetchSchedules() {
            this.isLoading = true;
            this.fetchAndCacheApointments(this.selectedOfficialForReview.id, this.selectedDate.format('YYYY-MM-DD')).then(() => {
                this.isLoading = false;
            });
        },
        performCancel(apt) {
            this.isLoading = true;
            this.cancelAppointment(apt).then(() => {
                this.isLoading = false;
                this.successToast(this.$t('toast-success-messages.cancel-appointment'));
                this.visible = false;
            }).catch(() => {
                this.isLoading = false;
                this.errorToast(this.$t('toast-error-messages.cancel-appointment'));
            });
        }
    },
    watch: {
        selectedDate() {
            if (this.isOfficialSelected) {
                this.fetchSchedules();
            }
        },
        selectedOfficialForReview() {
            if (this.isOfficialSelected) {
                this.fetchSchedules();
            }
        }
    }
})

</script>

